(() => {
  if (customElements.get('liene-wheel-terms')) return;
  customElements.define('liene-wheel-terms', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      const matches = href => {
        try {
          const url = new URL(href, location.href);
          return url.origin === location.origin && url.pathname === location.pathname &&
            url.search === location.search && url.hash === `#${this.dataset.anchor}`;
        } catch { return false; }
      };
      const open = opener => {
        if (this.dialog.open) return;
        this.opener = opener || document.activeElement;
        this.dialog.showModal();
      };
      // Delegation also handles links inserted after the Omnisend SDK loads.
      document.addEventListener('click', event => {
        const link = event.target.closest?.('a[href]');
        if (!link || !matches(link.href) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(link);
      }, options);
      window.addEventListener('hashchange', () => {
        if (location.hash === `#${this.dataset.anchor}`) open();
      }, options);
      this.querySelector('button').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (location.hash === `#${this.dataset.anchor}`) history.replaceState(history.state, '', location.pathname + location.search);
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      if (location.hash === `#${this.dataset.anchor}`) open();
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
    }
  });
})();
